import React, { useRef } from 'react';
import { PropTypes } from 'prop-types';
import { DateRangePicker } from 'react-date-range';
import styles from '../../styles/Tickets.module.scss';
import './DatePicker.scss';
import useClickAwayListener from '../../hooks/useClickAwayLitsner';

export default function DatePickerTickets({ handleClose, setEndDate, setStartDate, _state, _setState }) {
  const _startdate = new Date();
  const date = new Date();
  date.setDate(date.getDate() - 30);
  const popupRef = useRef(null);

  const handleApply = async () => {
    const startdate = _state[0].startDate;
    const enddate = _state[0].endDate;
    let strtDate = null;
    let endDt = null;
    let tempStrtDate = null;
    if (startdate) {
      tempStrtDate = `${startdate.getFullYear()}-${startdate.getMonth() + 1}-${startdate.getDate()}`;
      strtDate = `${tempStrtDate}`;
    }
    if (enddate) {
      endDt = `${enddate.getFullYear()}-${enddate.getMonth() + 1}-${enddate.getDate()}`;
    }
    if (!enddate && startdate) {
      endDt = `${tempStrtDate} `;
    }
    if (strtDate || endDt) {
      setEndDate(endDt);
      setStartDate(strtDate);
    }

    handleClose();
  };

  useClickAwayListener(popupRef, () => {
    handleClose();
  });

  return (
    <section className="cs_modal_feedback undefined">
      <div className="cs_modal_feedback_content cs_modal_animation fadeInUpTop" ref={popupRef}>
        <div className="cs_modal_body p-10">
          <div style={{ position: 'relative' }}>
            <div
              style={{
                maxWidth: '600px',
                width: 'calc(100%)',
                minWidth: '100%',
                height: '100%',
                overflowX: 'auto',
                marginTop: '10px',
              }}
            >
              <DateRangePicker
                onChange={(item) => _setState([item.selection])}
                showDateDisplay={false}
                showSelectionPreview
                moveRangeOnFirstSelection={false}
                months={1}
                ranges={_state}
                direction="horizontal"
                preventSnapRefocus
                calendarFocus="backwards"
                editableDateInputs={false}
                maxDate={new Date()}
              />
            </div>
            {/* Date Picker */}

            <div
              className={`${styles.Fixed__FloatBtnGroup}`}
              style={{ display: 'flex', bottom: '-8px', width: '100%', padding: '12px' }}
            >
              <button
                type="button"
                className={`${styles.Fixed__FloatButton} blue_whitefill_animate font14 fw600 color007`}
                onClick={() => {
                  setEndDate(`${_startdate.getFullYear()}-${_startdate.getMonth() + 1}-${_startdate.getDate()}`);
                  setStartDate(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`);
                  _setState([
                    {
                      startDate: _startdate,
                      endDate: date,
                      key: 'selection',
                    },
                  ]);
                  handleClose();
                }}
              >
                Clear
              </button>
              <button
                type="button"
                className={`${styles.Fixed__FloatButton} bluefill_animate font14 fw600 colorFFF`}
                onClick={() => handleApply()}
              >
                Apply
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

DatePickerTickets.propTypes = {
  handleClose: PropTypes.func,
  //   getTicketsData: PropTypes.func,
  setStartDate: PropTypes.func,
  setEndDate: PropTypes.func,
  _state: PropTypes.object,
  _setState: PropTypes.func,
};
